import { createNotificationWithPrintListener } from 'screens/Applications&WorkOrders/Components/Notification/genericNotification';
import { NotificationType } from 'screens/Applications&WorkOrders/Components/Notification/notificationConstants';
import './index.css';
import NOTIFICATION_STRINGS from './Constants/notificationString';

const CREATE_SUCCESS_KEY = 'work-order-create-success';
export const CREATE_CLASSNAME_PREFIX = 'work-order-creation';

interface WorkOrderNotificationOptions {
  onDuplicate?: () => void;
  onPrint?: () => void;
  onViewWorkOrder?: () => void;
  onRetry?: () => void;
}

const workOrderNotification = (
  type:
    | 'CREATE_SUCCESS'
    | 'EDIT_SUCCESS'
    | 'CREATE_OR_EDIT_ERROR'
    | 'DELETE_SUCCESS'
    | 'DELETE_ERROR'
    | 'CONVERSION_DELETE_ERROR'
    | 'PDF_EXPORT_ERROR',
  onClose: () => void = () => {},
  options?: WorkOrderNotificationOptions
) => {
  const notificationType: NotificationType = type as NotificationType;

  const notificationStrings = {
    SAVED: NOTIFICATION_STRINGS.WORK_ORDER_CREATED,
    UPDATED: NOTIFICATION_STRINGS.WORK_ORDER_UPDATED,
    DELETED: 'Work Order deleted.',
    DUPLICATE_BUTTON: NOTIFICATION_STRINGS.DUPLICATE_BUTTON,
    PRINT_PDF_BUTTON: NOTIFICATION_STRINGS.PRINT_PDF_BUTTON,
    ERROR_TITLE: NOTIFICATION_STRINGS.ERROR_TITLE,
    ERROR_MESSAGE: NOTIFICATION_STRINGS.ERROR_MESSAGE,
    DELETE_ERROR_TITLE: NOTIFICATION_STRINGS.DELETE_ERROR_TITLE,
    DELETE_ERROR_MESSAGE: NOTIFICATION_STRINGS.DELETE_ERROR_MESSAGE,
    CONTACT_BUTTON: NOTIFICATION_STRINGS.CONTACT_BUTTON,
    PDF_ERROR_TITLE: NOTIFICATION_STRINGS.PDF_ERROR_TITLE,
    PDF_ERROR_MESSAGE: NOTIFICATION_STRINGS.PDF_ERROR_MESSAGE,
    PDF_TRY_AGAIN_BUTTON: NOTIFICATION_STRINGS.PDF_TRY_AGAIN_BUTTON,
    VIEW_WORK_ORDER_BUTTON: NOTIFICATION_STRINGS.VIEW_WORK_ORDER_BUTTON
  };

  createNotificationWithPrintListener(
    notificationType,
    notificationStrings,
    CREATE_SUCCESS_KEY,
    CREATE_CLASSNAME_PREFIX,
    {
      onDuplicate: options?.onDuplicate,
      onPrint: options?.onPrint,
      onViewWorkOrder: options?.onViewWorkOrder,
      onRetry: options?.onRetry,
      onClose
    }
  );
};

export default workOrderNotification;
